import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { Path } from "../../constants/enum/path.emum";

const ScheduleItem = (props: { schedule: any; type: string }) => {
  const { schedule, type } = props;
  // Trype ข้อมูลคือจะเป็นไปได้  มคอ. หรือ อชว.

  return (
    <div className="col">
      <div className="card">
        <div className="ribbon ribbon-top-left">
          <span>ปี {schedule.year}</span>
        </div>
        <div className="card-body">
          <h4 className="card-title">
            <strong>เทอม {schedule.term}</strong>
          </h4>
          <div className="card-text">
            <strong>{type}3</strong>
            <br />
            {moment(schedule.doc3).add(543, "year").format("DD/MM/yyyy")}
          </div>
          <div className="card-text">
            <strong>{type}5</strong>
            <br />
            {moment(schedule.doc5).add(543, "year").format("DD/MM/yyyy")}
          </div>
          {/* <div className="card-text">จำนวนวิชา 5 ที่ต้องส่ง </div> */}
          {/* ส่งที่จะต้องไปตอนกดลิงค์ คือจะตัองมี schedule ไปด้วย */}
          <Link
            to={{ pathname: `${Path.SENDDOC}/${schedule.id}` }}
            className="btn btn-primary mt-2"
          >
            ส่งเอกสาร
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ScheduleItem;
